import { useCallback, useMemo } from 'react';
import find from 'lodash/find';
import isArray from 'lodash/isArray';
import map from 'lodash/map';

import {
  MultiSelectChangeCallbackType,
  MultiSelectDataType
} from '../../../../helpers/MultiSelect/types';
import { GroupedItemBindingStatuses } from '../../groupedItemsTypes';

import { useTranslate } from '../../../../common/hooks/useTranslate';

import { MultiSelect, MultiSelectProps } from '../../../../helpers/MultiSelect';

import { itemsKeys } from '../../../../locales/keys';

interface TagsMultiSelectProps {
  value: GroupedItemBindingStatuses[];
  autoFocus?: boolean;
  onChange: (value: GroupedItemBindingStatuses[]) => void;
}

const bindingStatusI18nTexts = {
  [GroupedItemBindingStatuses.BINDED]: itemsKeys.bindingStatuses.binded,
  [GroupedItemBindingStatuses.UNBINDED]: itemsKeys.bindingStatuses.postponed,
  [GroupedItemBindingStatuses.MIXED]: itemsKeys.bindingStatuses.mixed
};

function ItemsBindingStatusesMultiSelect({
  value,
  autoFocus,
  onChange
}: TagsMultiSelectProps & MultiSelectProps) {
  const { t } = useTranslate();

  const bindingStatusesData = useMemo<MultiSelectDataType[]>(() => {
    return map(bindingStatusI18nTexts, (i18nText, value) => ({
      label: t(i18nText),
      value
    }));
  }, [t]);

  const handleChange = useCallback<MultiSelectChangeCallbackType>(
    (value: MultiSelectDataType) => {
      onChange(isArray(value) ? value.map((item) => item.value) : []);
    },
    [onChange]
  );

  const multiSelectValue = useMemo<MultiSelectDataType[]>(() => {
    return isArray(value)
      ? value.map((item) => find(bindingStatusesData, ['value', item]))
      : [];
  }, [value, bindingStatusesData]);

  return (
    <MultiSelect
      inputWrapperClassName="block"
      onChange={handleChange}
      value={multiSelectValue}
      multi={true}
      isSearchable={true}
      data={bindingStatusesData}
      classNamePrefix="av_multi_select"
      autoFocus={autoFocus}
    />
  );
}

export default ItemsBindingStatusesMultiSelect;
